module.exports = __webpack_public_path__ + "static/media/subICloud4.daa118eb.png";